import { useState } from "react"
import { Link } from "react-router-dom"
import { Button } from "react-bootstrap"

import { useTranslation } from "react-i18next"
import { useAppDispatch, useAppSelector } from "../../redux/store"

import {
  IconAlertCircle,
  IconArrowLeft,
} from "../../components/utils/Icons/CustomIcons"
import { FaCaretRight } from "react-icons/fa6"
import chooseTypeNumber from "@/assets/images/chooseType.png"
import chooseTypeName from "@/assets/images/chooseTypeName.png"
import {
  setChooseType,
  resetInvitationState,
} from "@/redux/slices/invite/invitationSlice"
import Loader from "../../Loader"

type chooseType = {
  setActivePage: (step: string) => void
}
const ChooseType = ({ setActivePage }: chooseType) => {
  const { t } = useTranslation()
  const { chooseType } = useAppSelector((state) => state.invite)
  const dispatch = useAppDispatch()
  const [chosen, setChosen] = useState("name")

  return (
    <div className="container">
      <div className="mb-3 ">
        <Button
          className="d-flex align-items-center "
          style={{
            backgroundColor: "transparent",
            border: "none",
            color: "black",
          }}
          onClick={() => setActivePage("addInvitation")}
        >
          <IconArrowLeft />
          <span className="reminders-page__link-text">
            {t("buttons.backNew")}
          </span>
        </Button>
      </div>{" "}
      <div className="mb-4 d-flex justify-content-between">
        <h5 className="mb-3 fs-3 fw-normal">
          {" "}
          {/* {t("invitation.addInvitation")} */}
          Choose Type
        </h5>{" "}
      </div>
      <div className="container d-flex  flex-column   flex-md-row  gap-4 mb-3 ">
        <div className=" col-12 col-md-2  top-0  align-items-top d-flex justify-content-center  gap-1">
          <FaCaretRight />{" "}
          <h5
            style={{
              width: "230px",
              maxHeight: "200px",
              padding: "10px",
              border: "2px solid white",
              color: "#6D717A",
              textTransform: "capitalize", // Capitalizes the first letter of each word
            }}
          >
            Choose your invitation style by Name or Number for a quick and
            personalized selection.
          </h5>
        </div>
        <div className="col-12 col-md-8 col-lg-6 d-flex flex-column  top-0  align-items-top d-flex justify-content-center  ">
          <div
            className="d-flex flex-column flex-md-row f gap-2 "
            style={{ marginLeft: "auto" }}
          >
            <div className="d-none d-md-flex flex-column   col-12 col-md-4 gap-2 align-items-end ">
              <img
                src={chooseType === "name" ? chooseTypeName : chooseTypeNumber}
                style={{ width: "130px", height: "145px" }}
                alt="image"
              />{" "}
              <img
                style={{ width: "130px", height: "145px" }}
                src={chooseType === "name" ? chooseTypeName : chooseTypeNumber}
                alt="image"
              />
            </div>
            <div className=" col-12 col-md-4 align-items-start">
              <img
                src={chooseType === "name" ? chooseTypeName : chooseTypeNumber}
                style={{
                  width: "250px",
                  height: "300px",
                  objectFit: "cover",
                  objectPosition: "center",
                }}
                alt="image"
              />
            </div>
          </div>
          <div className=" d-flex flex-column flex-md-row gap-3 mt-3 ms-auto">
            {chooseType === "name" && (
              <>
                <button
                  type="submit"
                  // onClick={(e) => onSubmit(e, "")}
                  className="btn btn-dark"
                  style={{
                    marginTop: "auto",

                    width: "150px",
                    height: "40px",
                    borderRadius: "5px",
                    backgroundColor: "#20529B",
                    border: "none",
                  }} // Ensure it sticks to the bottom
                  onClick={() => dispatch(setChooseType("name"))}
                >
                  {t("buttons.name")}
                </button>
                <button
                  type="submit"
                  // onClick={(e) => onSubmit(e, "")}
                  className="btn btn-dark shadow-lg fw-bold"
                  style={{
                    marginTop: "auto",
                    width: "150px",
                    height: "40px",
                    borderRadius: "5px",
                    backgroundColor: "white",
                    color: "#20529B",
                    border: "none",
                  }} // Ensure it sticks to the bottom
                  onClick={() => dispatch(setChooseType("number"))}
                >
                  {t("buttons.number")}
                </button>
              </>
            )}
            {chooseType === "number" && (
              <>
                <button
                  type="submit"
                  // onClick={(e) => onSubmit(e, "")}
                  className="btn btn-dark shadow-lg fw-bold"
                  style={{
                    marginTop: "auto",
                    width: "150px",
                    height: "40px",
                    borderRadius: "5px",
                    backgroundColor: "white",
                    color: "#20529B",
                    border: "none",
                  }} // Ensure it sticks to the bottom
                  onClick={() => dispatch(setChooseType("name"))}
                >
                  {t("buttons.name")}
                </button>
                <button
                  type="submit"
                  // onClick={(e) => onSubmit(e, "")}
                  className="btn btn-dark"
                  style={{
                    marginTop: "auto",

                    width: "150px",
                    height: "40px",
                    borderRadius: "5px",
                    backgroundColor: "#20529B",
                    border: "none",
                  }} // Ensure it sticks to the bottom
                  onClick={() => dispatch(setChooseType("number"))}
                >
                  {t("buttons.number")}
                </button>
              </>
            )}
          </div>
        </div>
      </div>
      <div className="container  w-full d-flex  flex-column flex-md-row gap-4 mb-3 ">
        <button
          type="submit"
          // onClick={(e) => onSubmit(e, "")}
          className="btn btn-dark"
          style={{
            width: "150px",
            height: "40px",
            borderRadius: "5px",
            backgroundColor: "#20529B",
            border: "none",
            marginLeft: "auto",
            marginTop: "20px",
          }} // Ensure it sticks to the bottom
          // onClick={() => {
          //   setActivePage("addNames")
          // }}

          // onClick={handleSubmit}
        >
          {t("buttons.next")}
        </button>
      </div>
    </div>
  )
}

export default ChooseType
